import { useQuery } from 'react-query';

import { useApiContext } from 'context/ApiContext';
import { KEYS } from 'helpers/react-query.config';

const useHasTicketStatusChangePermission = (ticketId: number) => {
  const { ticket: ticketApi } = useApiContext();

  const { data, isFetching } = useQuery(
    [KEYS.ticket.tickets.getAvailableStatuses(), ticketId],
    () => ticketApi.tickets.getAvailableStatuses(ticketId),
    {
      select: (response) => response?.data?.data,
      enabled: !!ticketId,
      refetchOnWindowFocus: false
    }
  );

  return {
    data,
    isFetching
  };
};

export default useHasTicketStatusChangePermission;
